





















































import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import CheckIcon from '@/components/icons/Check.vue';

export type AlignmentOptions = 'bottomRight' | 'bottomLeft';
type Style = Record<string, string | number>;

const widgetSpace = '3px';

@Component<PlacementConfigRadio>({
  components: {
    Typography,
    CheckIcon
  },
  computed: {
    isChecked() {
      return this.modelValue === this.value;
    }
  }
})
export default class PlacementConfigRadio extends Vue {
  @Model('change', { default: '' }) modelValue?: string;

  @Prop({ default: '' }) value?: string;
  @Prop() alignment!: AlignmentOptions;
  @Prop() name!: string;
  @Prop() label!: string;
  @Prop({ default: false }) responsiveSmallGutter?: boolean;
  @Prop({ default: false }) disabled?: boolean;

  get widgetPlacementByAlignment() {
    const alignmentMap: Record<AlignmentOptions, Style> = {
      bottomRight: {
        right: widgetSpace,
        bottom: widgetSpace
      },
      bottomLeft: {
        bottom: widgetSpace,
        left: widgetSpace
      }
    };

    if (!alignmentMap[this.alignment]) return {};

    return alignmentMap[this.alignment];
  }
}
